module.exports = __webpack_public_path__ + "static/media/LogoMaruStd-Extra.9022fb70.svg";